import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trash-icon',
  templateUrl: './trash-icon.component.html',
  styleUrls: ['./trash-icon.component.scss']
})
export class TrashIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
